<template>
  <router-link
    v-if="internalUrlParam"
    class="button-secondary"
    :style="style"
    :to="{ name: 'page', params: { page: internalUrlParam || 'home' } }"
    @click.native="$emit('onClick')"
  >
    {{ label }}
  </router-link>

  <a
    v-else-if="url"
    class="button-secondary"
    :style="style"
    :href="url"
    target="_blank"
  >
    {{ label }}
  </a>

  <button
    v-else
    class="button-secondary"
    :style="style"
    @click="$emit('onClick')"
  >
    {{ label }}
  </button>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  label: String,
  black: Boolean,
  white: Boolean,
  url: String,
  internalUrlParam: Object,
});

const bgColor = computed(() => {
  return props.white
    ? `var(--white-70)`
    : props.black
    ? `var(--scala-grigi-gray-1)`
    : `var(--primary-yellow)`;
});

const hoverColor = computed(() => {
  return props.white
    ? `var(--white-100)`
    : props.black
    ? `var(--black-100)`
    : `var(--primary-yellow-light)`;
});

const style = computed(() => ({
  "--bg-color": bgColor.value,
  "--hover-color": hoverColor.value,
}));
</script>

<style lang="scss" scoped>
.button-secondary {
  @include link-s;

  color: var(--bg-color);
  text-align: left;
  transition: color 0.3s;

  &:hover:not(:disabled) {
    color: var(--hover-color);
  }
}
</style>
